import React from "react";
import StudentCard from "../StudentCard/StudentCard";
import StudentCardLong from "../StudentCardLong/StudentCardLong";
import styles from "./ProfessorDashboard.module.css";

function StudentsGrid({
  students,
  viewMode,
  onStudentView,
  onToggleSave,
  onStudentContact,
}) {
  return (
    <div
      className={
        viewMode === "card"
          ? `${styles.studentsGrid} ${styles.studentsGridCard}`
          : styles.studentsList
      }
    >
      {students.map((student) =>
        viewMode === "card" ? (
          <StudentCard
            key={student._id}
            student={student}
            onView={() => onStudentView(student)}
            onToggleSave={onToggleSave}
            onContact={() => onStudentContact(student)}
          />
        ) : (
          <StudentCardLong
            key={student._id}
            student={student}
            onView={() => onStudentView(student)}
            onToggleSave={onToggleSave}
            onContact={() => onStudentContact(student)}
          />
        )
      )}
    </div>
  );
}

export default StudentsGrid;
